import { main } from "@popperjs/core";



export default function newMainFilter() {

    const mainFilterTabs = document.querySelectorAll('.js-new-main-filter-tab');


    if ( mainFilterTabs.length ) {
        for (let tab of mainFilterTabs ) {
            tab.addEventListener('click',function(){
               let index = tab.dataset.tab;

               document.querySelector(`.new-main-filter__area_show`)?.classList.remove("new-main-filter__area_show");
               document.querySelector(`.js-new-main-filter-box[data-tab='${index}']`)?.classList.add("new-main-filter__area_show");

            });
        }
    }

}